// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__2zWA-","errorLogs":"EditorFooter_errorLogs__2gX7u"};